import React, { useEffect, useState, useRef } from 'react';
import { Space, notification, Tooltip, Popover, Modal, Tag } from 'antd';
// import { XIcon } from '@heroicons/react/outline';
import { ReloadOutlined } from '@ant-design/icons';
import Table from 'components/Table';
import { useSelector } from 'react-redux';
import './assets/style.css';
import { Breadcrumbs } from '../../components/Atom/breadcumbs';
import { PageHeader } from '../../components/Atom/PageHeader';
import { ResetButton, FilterButton } from '../../components/Atom/Button';
import SearchField from '../../components/Atom/SearchField';
import http from '../../utils/http';
import Filter from './assets/filter';
import { CURRENCIES } from '../../utils/currencies';
import StatusTag from 'components/Atom/StatusTag';
import ShortenId from 'components/Atom/ShortenId';
import { handleDateRangeFormat, formatAmount, convertToStoreTimezone, handleStateByPassData } from 'utils/services';
import { TIMEZONES } from '../../utils/constant';
import { useNavigate, useLocation } from 'react-router-dom';
import { useQuery } from 'react-query';
import moment from 'moment';

const PaymentIntent = () => {
  const store = useSelector((state) => state.company.store);
  const navigate = useNavigate();
  const location = useLocation();
  const [recordId, setRecordId] = useState('');
  const [delayTimer, setDelayTimer] = useState();
  const tableContainerRef = useRef(null);
  const [isDefaultRange, setIsDefaultRange] = useState(false);
  const defaultDateApplied = useRef(false);
  const columnsData = [
    {
      title: 'Order / Payment Id',
      render: (value) => value?.metadata?.order_reference ?? '-',
      key: 'order',
    },
    {
      title: 'Email / Phone Number',
      render: (value) => (value?.customer?.email ? value?.customer?.email : value?.customer?.phone),
      key: 'email',
    },
    {
      title: 'Amount',
      render: (value) => `${value?.currency} ${formatAmount(value?.amount, value?.currency)}`,
      key: 'amount',
    },
    {
      title: 'Intent ID',
      render: (value) => <ShortenId value={value?._id} />,
      key: 'intent_id',
    },
    {
      title: 'Status',
      render: (value) => <StatusTag tag={value?.status} />,
      key: 'status',
    },
    {
      title: 'Time',
      render: (value) => (value?.last_update ? value?.last_update : value?.created_at),
      key: 'time',
    },
  ];
  const [search, setSearch] = useState('');
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);

  const filtersDataValues = (data) => {
    let filtersData = {};
    if (data?.date_range) {
      const timezone = store?.isSelected ? store?.settings?.timezone || TIMEZONES.PKT : null;
      const { start_date, end_date } = handleDateRangeFormat(data?.date_range, timezone);
      filtersData.start_date = start_date;
      filtersData.end_date = end_date;
    }
    filtersData.status = data?.intent_status ?? null;
    filtersData.paymentType = data?.paymentType ?? null;
    filtersData.gateway = data?.gatewayType ?? null;
    return filtersData;
  };
  const handleFiltersSearch = (data) => {
    setIsDefaultRange(false);
    setQueryParams((pre) => ({ ...pre, offset: 0, currentPage: 1, filtersData: data }));
    setTrigerApi(!trigerApi);
  };
  const fetchData = async (queryParams) => {
    try {
      const paramsData = { offset: queryParams?.offset, limit: queryParams?.limit };
      if (queryParams?.search !== '') {
        paramsData['search_key'] = queryParams?.search;
      }
      const formattedData = filtersDataValues(queryParams?.filtersData);
      const params = { ...paramsData, ...formattedData, ...(store?.isSelected && { store_id: store?._id }), xap_request: true };
      const response = await http.get(`/public/v1/payment/intent/data`, { params });
      const timezone = store?.settings?.timezone || TIMEZONES.PKT;
      const result = await convertToStoreTimezone(response?.data?.data?.docs, timezone);
      response.data.data.docs = result;
      if (response.data.data?.defaultEndDate && response.data.data?.defaultStartDate) {
        setIsDefaultRange(true);
        setQueryParams((prev) => ({
          ...prev,
          filtersData: {
            ...prev.filtersData,
            date_range: [moment(response.data.data?.defaultStartDate), moment(`${response.data.data?.defaultEndDate?.replace(' ', 'T')}Z`)],
          },
        }));
      }
      return response.data.data;
    } catch (err) {
      console.log(err);
    }
  };
  const { data, refetch, isLoading, isFetching } = useQuery('paymentIntent', () => fetchData(queryParams), {
    enabled: false,
    manual: true,
  });
  const [queryParams, setQueryParams] = useState({
    offset: 0,
    limit: 20,
    search: '',
    currentPage: 1,
  });
  const [trigerApi, setTrigerApi] = useState(true);
  useEffect(() => {
    if (location?.state?.isRedirection && data) {
      setSearch(location?.state?.searchValue);
      setRecordId(location?.state?.id);
      navigate(location.pathname, { replace: true });
      const data = handleStateByPassData(location?.state?.filtersData, true);
      if (!data) {
        refetch();
      }
      setQueryParams(data);
      setTimeout(() => {
        if (tableContainerRef?.current && location?.state?.id) {
          const row = document?.querySelector(`.custom-row-class.highlighted-row`);
          if (row) {
            row?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }
        }
      }, 10);
      return;
    } else if (location?.state?.isRedirection) {
      navigate(location.pathname, { replace: true });
    }
    refetch();
  }, [trigerApi, store]);

  useEffect(() => {
    if (!data || defaultDateApplied.current) return;
    if (queryParams?.filtersData?.date_range) return;
    if (!data.defaultStartDate || !data.defaultEndDate) return;

    defaultDateApplied.current = true;
    setIsDefaultRange(true);
    setQueryParams((prev) => ({
      ...prev,
      filtersData: {
        ...prev.filtersData,
        date_range: [moment(data.defaultStartDate), moment(`${data?.defaultEndDate?.replace(' ', 'T')}Z`)],
      },
    }));
  }, [data, queryParams?.filtersData?.date_range]);

  const handelCurrencyCode = (code) => {
    const symbol = CURRENCIES[code.toUpperCase()];
    return symbol?.symbol_native ?? 'Rs';
  };
  const getSearch = async (e) => {
    if (e === '' || e == null) {
      notification.error({ message: 'Please enter details for search', placement: 'bottomRight' });
    } else {
      setQueryParams((pre) => ({ ...pre, currentPage: 1, offset: 0, search: e }));
      setTrigerApi(!trigerApi);
    }
  };

  const handlePagePageChange = (page, pageSize) => {
    if (queryParams?.limit !== pageSize) {
      setQueryParams((pre) => ({ ...pre, limit: pageSize, offset: 0, currentPage: 1 }));
      setTrigerApi(!trigerApi);
    } else {
      const countOffset = page * queryParams?.limit - queryParams?.limit;
      setQueryParams((pre) => ({ ...pre, limit: pageSize, offset: countOffset, currentPage: page }));
      setTrigerApi(!trigerApi);
    }
  };

  const handleSearch = (e) => {
    if (delayTimer && e !== '' && e !== null) {
      clearTimeout(delayTimer);
    }
    setSearch(e.target.value.trim());
  };
  const handleSearchData = () => {
    if (delayTimer) {
      clearTimeout(delayTimer);
    }
    const newTimer = setTimeout(() => {
      handleRefresh();
    }, 1500);
    setDelayTimer(newTimer);
  };
  const handleRefresh = (isRefresh = true) => {
    if (isRefresh) {
      setSearch(null);
      defaultDateApplied.current = false;
    } else {
      setIsFilterModalOpen(false);
    }
    if (isRefresh) {
      setIsDefaultRange(false);
    }
    setQueryParams((pre) => ({ ...pre, offset: 0, currentPage: 1, search: '', filtersData: isRefresh ? pre?.filtersData : null }));
    setTrigerApi(!trigerApi);
  };
  const handleCloseFilterModel = () => {
    setIsFilterModalOpen(!isFilterModalOpen);
  };
  const [filterToggle, setFilterToggle] = useState(false);
  const filterToggler = () => {
    setFilterToggle(true);
  };
  const handleReset = () => {
    setIsDefaultRange(false);
    setQueryParams((prev) => ({ ...prev, offset: 0, currentPage: 1, filtersData: {} }));
    setTrigerApi(!trigerApi);
    setIsFilterModalOpen(false);
  };
  const popOverContent = (
    <div className='popOver'>
      <div className='popover_header mt-2 mb-3 flex items-center gap-2'>
        <span style={{ fontWeight: '700', color: '#262626' }}>Filter</span>
        <div className='flex items-center text-[#000000] gap-2 cursor-pointer' onClick={() => handleReset()}>
          <ReloadOutlined style={{ fontSize: '16px' }} />
          <span style={{ color: '#000000', fontSize: '14px', lineHeight: '24px' }}>Reset All</span>
        </div>
      </div>
      <div className=''>
        <Filter filterToggler={filterToggler} filtersData={queryParams?.filtersData} onSearch={handleFiltersSearch} handleClose={handleCloseFilterModel} />
      </div>
    </div>
  );
  const breadcrumbProps = {
    breadcrumbs: [
      {
        name: 'XPay',
        href: '/xpay',
      },
      {
        name: 'Payment Intents',
      },
    ],
  };
  const handleRowHover = () => {
    setRecordId('');
  };
  return (
    <div style={{ padding: '0px', width: '100%' }}>
      <div className='header-container'>
        <Breadcrumbs {...breadcrumbProps} />
        <div className='headerPage'>
          <div className=''>
            <PageHeader label='Payment Intents' button={<ResetButton onClick={isFetching ? '' : handleRefresh} loading={isFetching} />} />
          </div>
        </div>
      </div>
      <div className='actionPanel'>
        <div className='headerContainer' style={{ width: '100%' }}>
          <Popover
            className={isFilterModalOpen ? 'filter-active filterPopover' : filterToggle ? 'text-base activeFilterToggler filterPopover' : 'text-base filterPopover'}
            trigger='click'
            placement='bottomLeft'
            content={popOverContent}
            open={isFilterModalOpen}
            destroyTooltipOnHide
            onOpenChange={() => {
              handleCloseFilterModel();
            }}>
            <FilterButton onClick={() => setIsFilterModalOpen(true)}>
              <div className='text-base'>Filter</div>
            </FilterButton>
          </Popover>
          <div className='searchInput' style={{ width: '100%' }}>
            <SearchField
              handleOnChange={handleSearch}
              value={search}
              handlePressEnter={getSearch}
              onReset={handleSearchData}
              placeholder={'Search by Intent ID, Order ID, Email, Phone'}
              loading={!!(isFetching && search)}
              dropdown={{ show: false }}
              enableSearchBtn={true}
            />
          </div>
        </div>
      </div>

      {isDefaultRange && data?.defaultStartDate && data?.defaultEndDate && (
        <div className='mt-2'>
          <Tag>
            <strong className='text-black'>{moment(data?.defaultStartDate).format('MMM D, YYYY h:mm A')}</strong> to{' '}
            <strong className='text-black'>{moment(`${data?.defaultEndDate?.replace(' ', 'T')}Z`).format('MMM D, YYYY h:mm A')}</strong>
          </Tag>
        </div>
      )}
      {!isDefaultRange && queryParams?.filtersData?.date_range?.length === 2 && (
        <div className='mt-2'>
          <Tag>
            <strong className='text-black'> {moment(queryParams.filtersData.date_range[0]).format('MMM D, YYYY h:mm A')}</strong> to{' '}
            <strong className='text-black'>{moment(queryParams.filtersData.date_range[1]).format('MMM D, YYYY h:mm A')}</strong>
          </Tag>
        </div>
      )}
      <br />
      <div className='overflow-x-auto custom-table' ref={tableContainerRef}>
        <Table
          loading={isLoading}
          dataSource={data?.docs}
          columns={columnsData}
          onRow={(record) => {
            return {
              onClick: (event) => {
                const { className } = event?.target;
                if (!className?.includes('table-action-btn')) {
                  navigate(`/paymentIntent/${record?._id}`, { state: { record, id: record?._id, filtersData: handleStateByPassData(queryParams), searchValue: search } });
                }
              },
              onMouseEnter: handleRowHover,
              className: `custom-row-class ${recordId === record?._id ? 'highlighted-row' : ''}`,
            };
          }}
          totalLenght={data?.totalDocs}
          pagingation={{ handlePageChange: handlePagePageChange, perPageSize: queryParams?.limit, page: queryParams?.currentPage }}
        />
      </div>
    </div>
  );
};
export default PaymentIntent;
